import {
  CHASE_FREEDOM_UNLIMITED_OFFER_ID,
  CHASE_SAPPHIRE_PREFERRED_OFFER_ID,
} from '@cc-shopping/platform-absmartly/transforms/constants';
import {
  SEGMENT_DEPLOYABLE_NAME,
  SEGMENT_DEPLOYABLE_VERSION,
} from '@cc-shopping/platform-analytics/lib/constants';
import { env } from '@cc-shopping/platform-env';

export const APPLY_LINK_ALT = 'dta';

export const CHASE_LANDING_PAGES: Record<string, { altLinkName: string; pathnames: string[] }> = {
  [CHASE_FREEDOM_UNLIMITED_OFFER_ID]: {
    altLinkName: 'cfu_lp',
    pathnames: [
      '/credit-cards/best',
      '/credit-cards/best/cash-back',
      '/credit-cards/m/best/bonus-offers',
      '/credit-cards/m/best/rewards',
    ],
  },
  [CHASE_SAPPHIRE_PREFERRED_OFFER_ID]: {
    altLinkName: 'csp_lp',
    pathnames: ['/credit-cards/best', '/credit-cards/best/airline'],
  },
};

export const FORWARDED_PARAMS = [
  'calling_deployable_name',
  'calling_deployable_version',
  'cta_type',
  'deployable_name',
  'deployable_version',
  'finish_type',
  'id',
  'impression_page_name',
  'impression_page_url',
  'impression_pageview_id',
  'impression_position',
  'impression_section',
  'institution_id',
  'institution_name',
  'monetizable',
  'nw_plus_eligible',
  'offer_id',
  'offer_name',
  'product_id',
  'product_name',
  'shopping_finish_id',
  'sku_id',
  'sku_impression_id',
  'sku_level',
  'sku_name',
  'sku_product_type',
  'sku_source',
  'traditional_device_id',
] as const;

export type ForwardedParam = (typeof FORWARDED_PARAMS)[number];

export const PARTNER_PARAM_DEFAULTS: Partial<Record<ForwardedParam, string>> = {
  calling_deployable_name: SEGMENT_DEPLOYABLE_NAME,
  calling_deployable_version: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || SEGMENT_DEPLOYABLE_VERSION,
  cta_type: 'APPLY_NOW_BUTTON',
  impression_page_name: 'Missing',
  impression_page_url: 'Missing',
  impression_pageview_id: 'Missing',
  impression_position: '0',
  impression_section: 'Missing',
  institution_id: 'Missing',
  institution_name: 'Missing',
  monetizable: 'Missing',
  offer_id: 'Missing',
  offer_name: 'Missing',
  product_id: 'Missing',
  product_name: 'Missing',
  sku_id: 'Missing',
  sku_impression_id: 'Missing',
  sku_level: 'Missing',
  sku_name: 'Missing',
  sku_product_type: 'Missing',
  sku_source: 'Missing',
  traditional_device_id: 'Missing',
};
